import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import Header from './Header'
import Footer from './Footer'
import Modal from '../components/Modal'
import Alert from '../components/Alert'
import Notification from '../components/Notification'
import { loadUser, redirect, home, handleError, dismissNotification, getSubscribers, getCalls, getConfig, dismissMaintenanceInfoAlert } from '../actions'

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pollingHandles: []
        }
    }
    componentDidMount() {
        this.onLoad()
    }
    componentDidUpdate() {
        this.onLoad()
    }
    componentWillUnmount() {
        this.state.pollingHandles.forEach(clearInterval)
    }
    onLoad() {
        if (this.props.user) {
            if (!this.state.dataLoadingInitialized) {
                this.loadData()
            } else if (!this.props.enablePolling) {
                this.state.pollingHandles.forEach(clearInterval)
            }
        } else {
            if (this.state.dataLoadingInitialized || this.state.pollingHandles.length) {
                this.state.pollingHandles.forEach(clearInterval)
                this.setState({
                    dataLoadingInitialized: false,
                    pollingHandle: []
                })
            }
            if (!(this.state.isLoggingIn)) {
                this.setState({ isLoggingIn: true }, () => {
                    this.props.loadUser().catch(err => {
                        this.props.redirect('/login')
                    }).then(() => {
                        this.setState({ isLoggingIn: false })
                    })
                })
            }
        }
    }
    loadSubscribers() {
        const { getSubscribers, handleError } = this.props
        if (!this.subscribersLoading) {
            this.subscribersLoading = true
            getSubscribers()
                .catch(handleError)
                .then(() => this.subscribersLoading = false)
        }
    }
    loadCalls() {
        const { getCalls, handleError } = this.props
        if (!this.callsLoading) {
            this.callsLoading = true
            getCalls()
                .catch(handleError)
                .then(() => this.callsLoading = false)
        }
    }
    loadConfig() {
        const { getConfig, handleError } = this.props
        if (!this.configLoading) {
            this.configLoading = true
            getConfig()
                .catch(handleError)
                .then(() => this.configLoading = false)
        }
    }
    loadData() {
        const { enablePolling, getSubscribers, getCalls, getConfig, handleError } = this.props
        getSubscribers({ online: true }).catch(handleError)
        this.loadSubscribers()
        this.loadCalls()
        this.loadConfig()
        const newState = { dataLoadingInitialized: true }
        if (enablePolling && !this.state.pollingHandles.length) {
            newState.pollingHandles = [
                setInterval(() => this.loadSubscribers(), 15000),
                setInterval(() => this.loadCalls(), 5000),
                setInterval(() => this.loadConfig(), 30000)
            ]
        }
        this.setState(newState)
    }
    render() {
        const { maintenanceInfo } = this.props
        return (
            <div id="app">
                {maintenanceInfo &&
                    <Alert onClose={() => this.props.dismissMaintenanceInfoAlert(maintenanceInfo.id)}>
                        <strong>Maintenance-Info:</strong> {maintenanceInfo.text}
                    </Alert>
                }
                <div id="notifications">
                    {this.props.notifications.map((n, idx) =>
                        <Notification key={idx} notification={n} onDismiss={() => this.props.dismissNotification(idx)} />
                    )}
                </div>
                <div id="content">
                    {this.props.children}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const dataReady = state.subscribers && state.subscribers.length > 0
    return {
        user: state.user,
        dataReady,
        activeView: state.activeView,
        notifications: state.notifications,
        maintenanceInfo: state.config.maintenanceInfo && !(state.preferences.dismissedMaintenanceInfo >= state.config.maintenanceInfo.id) && state.config.maintenanceInfo,
        enablePolling: state.config.enablePolling
    }
}

export default connect(mapStateToProps, { redirect, home, handleError, dismissNotification, getSubscribers, getCalls, getConfig, loadUser, dismissMaintenanceInfoAlert })(App)


// WEBPACK FOOTER //
// ./containers/App.jsx